import PropTypes from 'prop-types'
import React from 'react'
import { injectIntl, FormattedMessage } from 'react-intl'
import { LAYOUT_NAME_MAX_LENGTH } from 'const/limits'
import {
  ControlLabel
} from 'react-bootstrap'
import {
  ListItem
} from 'components/List'
import EditableModal from 'components/EditableModal'
import {
  ViewBody
} from 'components/Sidebar'

export class LayoutName extends React.Component {
  static propTypes = {
    layoutId: PropTypes.number.isRequired,
    name: PropTypes.string,

    permission: PropTypes.object.isRequired,

    requestChangeLayoutName: PropTypes.func.isRequired,

    intl: PropTypes.object.isRequired,
  }

  state = {
    isEditing: false
  }

  componentDidUpdate = () => {
    const { permission } = this.props
    const { isEditing } = this.state

    if (
      !permission.owner &&
      isEditing
    ) {
      this.stopEditing()
    }
  }

  handleIsEditingChange = (isEditing) => {
    this.setState({
      isEditing
    })
  }

  handleEditableValidate = ({ name }) => {
    const { intl } = this.props

    const errors = {}

    if (!name) {
      errors.name = intl.formatMessage({ id: 'DESK_NAME_EMPTY' })
    } else if (name.length > LAYOUT_NAME_MAX_LENGTH) {
      errors.name = intl.formatMessage({ id: 'DESK_NAME_TOO_LONG' }, { limit: LAYOUT_NAME_MAX_LENGTH })
    }

    return errors
  }

  handleEditableSubmit = ({ name: newName }) => {
    const { layoutId, name, requestChangeLayoutName } = this.props

    if (newName !== name) {
      requestChangeLayoutName({
        id: layoutId,
        name: newName
      })
    }

    this.stopEditing()
  }

  stopEditing = () => {
    this.setState({
      isEditing: false
    })
  }

  renderName = () => {
    const {
      name
    } = this.props

    return (
      <ListItem>
        {name}
      </ListItem>
    )
  }

  render () {
    const {
      permission,

      name
    } = this.props
    const {
      isEditing
    } = this.state

    return (
      <div>
        <ViewBody>
          <ControlLabel><FormattedMessage id='DESK_NAME' /></ControlLabel>
        </ViewBody>
        {permission.owner ? (
          <EditableModal
            initialValues={{ name }}
            isEditing={isEditing}
            onIsEditingChange={this.handleIsEditingChange}
            validate={this.handleEditableValidate}
            onSubmit={this.handleEditableSubmit}
          >
            {this.renderName()}
          </EditableModal>
        ) : (
          this.renderName()
        )}
      </div>
    )
  }
}

export default injectIntl(LayoutName)
